const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

const generateId = () => `${s4()}x${s4()}`

export default  generateId
